// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const paperReam = defineModel({
  id: "paper-ream",
  batchId: "future",
  name: "Paper ream",
  tags: ["scenery","paper","ream","low-poly","age-of-mcp","future"],
  summary: "Reams of paper — books, maps, records and banknotes.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.36,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.34, 0.035, 0.24), color: "#eee9dc", position: [-0.008, 0.0175, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.035, 0.24), color: "#eee9dc", position: [0.008, 0.0525, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.035, 0.24), color: "#eee9dc", position: [-0.008, 0.0875, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.035, 0.24), color: "#eee9dc", position: [0.008, 0.1225, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.035, 0.24), color: "#eee9dc", position: [-0.008, 0.1575, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.035, 0.24), color: "#eee9dc", position: [0.008, 0.1925, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.035, 0.24), color: "#eee9dc", position: [-0.008, 0.2275, 0] },
      { geometry: new THREE.BoxGeometry(0.22, 0.08, 0.22), color: "#e2dccb", position: [0, 0.285, 0], rotation: [0, 0.12, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.09, 0.025), color: "#8a6a3a", position: [0, 0.285, 0], rotation: [0, 0.12, 0] },
      { geometry: new THREE.BoxGeometry(0.025, 0.09, 0.24), color: "#8a6a3a", position: [0, 0.285, 0], rotation: [0, 0.12, 0] },
    ],
  animations: [],
});
